import * as Cookie from './cookie';

function request(url: string, method: string = "GET", data: any = null): any {
	return new Promise((resolve, reject) => {
		let req = new XMLHttpRequest();
		req.open(method, url, true);
		if (method === "POST") {
			req.setRequestHeader("X-CSRF-TOKEN", Cookie.getCookie("CSRF-TOKEN"));
			req.setRequestHeader("content-type", "application/json");
		}
		req.onreadystatechange = function () {
			if (req.readyState !== 4)
				return;

			if (req.status >= 500)
				return reject(new Error('Error processing request - Please try again later'));
			if (req.status !== 200)
				return reject(new Error(req.response));

			resolve(JSON.parse(req.response));
		};
		req.onerror = function (err) {
			reject(err);
		};
		req.send(data);
	});
}

function getUrlParams(name): string {
	var params = new URLSearchParams(window.location.search.substr(1));
	return params.get(name);
}

export { request, getUrlParams }